"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectStatusOptions = void 0;
exports.projectStatusOptions = new Set([
    { text: 'Open', value: 'OPEN' },
    { text: 'Bid', value: 'BID' },
    { text: 'Bid Won', value: 'BID_WON' },
    { text: 'Bid Lost', value: 'BID_LOST' },
    { text: 'Complete', value: 'COMPLETE' },
    { text: 'Warranty', value: 'WARRANTY' },
    { text: 'Void', value: 'VOID' },
]);
